


import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {InteractiveObject} from '@/interfaces/entities/forest-game.interface';
import ForestGameService from '@/services/forest-game.service';
import ApiService from '@/services/api.service';
import TranslationsService from '@/services/translations.service';
import {finalize, map, mergeMap} from 'rxjs/operators';
import MapFeaturesService from '@/services/map-features.service';
import GameMapService from '@/services/game-map.service';
import {ForestGame} from '@/library/forest-game/forest-game';
import {AxiosResponse} from 'axios';
import GameUserPosition from '@/interfaces/geo/game-user-position';
import PopupService from '@/services/popup.service';

declare const jQuery: any;

@Component({})
export default class AppForestGame extends Vue {

  @Prop()
  public game!: ForestGame;

  @Prop({default: false})
  public gameReady!: boolean;

  @Emit('game-start-time')
  public emitGameStartTime(startTime: string): string {
    return startTime;
  }

  @Emit('game-end-time')
  public emitGameEndTime(endTime: string): string {
    return endTime;
  }

  @Emit('open-interactive-object')
  public emitOpenInteractiveObject(interactiveObject: InteractiveObject): InteractiveObject {
    return interactiveObject;
  }

  private forestGameService: ForestGameService = ForestGameService.getInstance();
  private popupService: PopupService = PopupService.getInstance();
  private apiService: ApiService = ApiService.getInstance();
  public translations: TranslationsService = TranslationsService.getInstance();
  public mapFeaturesService: MapFeaturesService = MapFeaturesService.getInstance();
  public gameMapService: GameMapService = GameMapService.getInstance();
  public interactiveObjects: InteractiveObject[] = [];
  public orderByNearby: boolean = false;
  public loading: boolean = false;
  private lastGameUserPosition: GameUserPosition | null = null;

  public created(): void {
    if (this.game.isStarted() && !this.game.isEnded()) {
      this.forestGameService.hideSummary();
    }
    this.gameMapService.whenGameLocationChanged.subscribe((position: GameUserPosition) => {
      this.lastGameUserPosition = position;
      this.setInteractiveObjects();
    });
  }

  public mounted(): void {
    this.setInteractiveObjects();
  }

  public toggleOrderByNearby(): void {
    this.setInteractiveObjects();
  }

  public showInstruction(): void {
    this.popupService.open('infoGameInstruction').subscribe();
  }

  public selectObjectFromList(interactiveObject: InteractiveObject): void {
    this.emitOpenInteractiveObject(interactiveObject);
  }

  public isInteractiveObjectDisabled(interactiveObject: InteractiveObject): boolean {
    return this.game.isEnded() || this.game.isInteractiveObjectCompleted(interactiveObject);
  }

  public deadlineNotice(): string {
    let message = '';
    if (this.game.deadline() && this.game.deadlineUnits() !== '0') {
      message = `Tev būs ${this.game.deadline()} ${this.deadlineUnit()}, lai izietu spēli`;
    }
    return message;
  }

  private deadlineUnit(): string {
    const units: { [key: string]: string } = {
      '0': '',
      '1': 'minūte',
      '2': 'stunda',
      '3': 'diena',
      '4': this.game.deadline() > 1 ? 'mēneši': 'mēnesis'
    };
    return (this.game.deadline() > 1 && this.game.deadlineUnits() != '4') ? `${units[this.game.deadlineUnits()]}s` : units[this.game.deadlineUnits()];
  }

  public startGame(): void {
    if (this.needAuthenticate()) {
      jQuery('.overlay-profile').show();
    } else {
      this.loading = true;
      this.forestGameService.startGame(this.game).pipe(
          map((response: AxiosResponse) => {
            this.emitGameStartTime(response.data.data.gameStarted);
            this.emitGameEndTime(response.data.data.deadline);
            this.game.updateUserCompletedTasks(response.data.data.completedObjects)
          }),
          mergeMap(() => this.gameMapService.startGame(this.game.lvmGeoId())),
          finalize(() => this.loading = false),
      ).subscribe({
        error: (error: Error) => {
          this.popupService.open('infoError').subscribe();
        }
      });
    }
  }

  private setInteractiveObjects(): void {
    this.interactiveObjects = this.orderByNearby && this.lastGameUserPosition
        ? this.game.interactiveObjectsOrderedByDistance(this.lastGameUserPosition.distances)
        : this.game.interactiveObjects();
  }

  private needAuthenticate(): boolean {
    return this.game.onlyForRegistered() && !this.apiService.user().isAuthenticated;
  }
}
